import { render } from "./CarrouselPrincipal.vue?vue&type=template&id=6fe29cbe&scoped=true"
const script = {}

import "./CarrouselPrincipal.vue?vue&type=style&index=0&id=6fe29cbe&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe29cbe"]])

export default __exports__